<template>
  <section class="h-44 overflow-auto shadow-2xl bg-white rounded-lg p-4">
    <div class="w-full">
      <div
        v-for="(item, index) in filteredDepositAccounts"
        :key="index"
        :class="
          !isTransferable(item.currency)
            ? 'cursor-not-allowed opacity-20'
            : 'cursor-pointer'
        "
        v-on="
          isTransferable(item.currency)
            ? { click: () => setCurrency(item.currency) }
            : {}
        "
        class="mb-2"
      >
        <el-tooltip
          class="item"
          effect="dark"
          :disabled="isTransferable(item.currency)"
          :content="getTransferDetail(item.currency)"
          placement="right"
        >
          <div
            class="flex justify-between items-center p-4"
            :class="
              (isSourceCurrency && country.currency === item.currency) ||
              (!isSourceCurrency && country2.currency === item.currency)
                ? 'bg-bg-muted rounded-lg'
                : ''
            "
          >
            <div class="flex gap-x-4">
              <currency-icons
                :currency="getCurrencyCountry(item.currency)"
                size="w-8 h-8"
              />
              <div>
                <p class="text-sm font-bold text-root-2 capitalize">
                  {{ item.currency }} Balance
                </p>
                <p class="text-xs text-fg-muted font-normal">
                  Bal:
                  {{ parseMoneyAll(item.currentBalance, item.currency) }}
                </p>
              </div>
            </div>
            <small-check
              v-if="
                (isSourceCurrency && country.currency === item.currency) ||
                (!isSourceCurrency && country2.currency === item.currency)
              "
            />
          </div>
        </el-tooltip>
      </div>
    </div>
  </section>
</template>
<script>
import { GetCurrencyCountry, ParseMoneyAll } from '@/utils/helpers.js'
import totalAccounts from '@/mixins/getBalance.js'
import exchangeRateBase from '@/mixins/localDeposit.js'
import getTransferDetail from '@/mixins/terminal.js'
export default {
  props: {
    currencyType: {
      type: String,
      default: ''
    }
  },
  mixins: [totalAccounts, exchangeRateBase, getTransferDetail],
  components: {
    CurrencyIcons: () => import('@/assets/icons/CurrencyIcons.vue'),
    SmallCheck: () => import('@/assets/v2/icons/SmallCheck.vue')
  },
  methods: {
    getCurrencyCountry (val) {
      return GetCurrencyCountry(val)
    },
    parseMoneyAll (amount, currency) {
      return ParseMoneyAll(amount, currency)
    }
  },
  computed: {
    isSourceCurrency () {
      return this.currencyType === 'source'
    },
    walletAddresses () {
      return this.$store.state.transactions.walletAddresses.items || []
    },
    transferStableCoins () {
      return process.env.VUE_APP_TRANSFER_STABLE_COINS === 'true'
    }
  }
}
</script>
<style scoped>
.box {
  box-shadow: 0px 8px 16px 0px #0302071a;
  box-shadow: 0px 0px 1px 0px #0302071a;
}
</style>
